import cx from 'classnames'
import Styles from './PropertyItem.module.scss'
import PropertyIcon from './PropertyIcon'
import { Property } from 'api/clients/PropertyClient'
import { PropertyActions } from 'common/PropertyActions/PropertyActions'
import { ReactComponent as DragVertical } from './icons/drag-vertical.svg'
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down--small__16.svg'
import { Response } from 'request-dot-js'
import { usePropertiesPermissions } from 'hooks/usePropertiesPermissions'
import { FC } from 'react'

interface Props {
  property: Property
  availableProperties?: Property[]
  actionsOpen?: boolean
  onSearch?: (query: string) => void
  onRemove?: () => void
  onCreate?: (property: Property) => void
  onUpdate?: (property: Property, isUndoAction?: boolean) => Promise<Response<{ property: Property }>>
  openPropertyActions?: (propertyId: number | undefined) => void
  draggable?: boolean
  icon?: FC<any>
}

const renderPropertyName = (name: string) => {
  if (name === 'Post Date & Time') return 'Post Date'
  return name
}

// TODO move to components since it's just used on references

export const PropertyItem = ({
  property,
  availableProperties = [],
  actionsOpen,
  openPropertyActions,
  onRemove,
  onCreate,
  onUpdate,
  onSearch,
  draggable = false,
  icon: Icon = PropertyIcon,
}: Props) => {
  const { canEdit, canRemove } = usePropertiesPermissions(property)
  const canAct = canEdit || canRemove

  return (
    <>
      <div
        className={cx(Styles.item, {
          [Styles.editItem]: actionsOpen,
        })}
      >
        {draggable && <DragVertical className={Styles.dragVertical} />}
        <div
          className={cx(Styles.propertiesCell, {
            [Styles.editPropertiesCell]: actionsOpen,
          })}
          onClick={() => {
            canAct && openPropertyActions && openPropertyActions(property.id)
          }}
        >
          <Icon type={property.type} defaultType={property.default_type} />
          <span data-testid="propertyTitle" className={Styles.title}>
            {renderPropertyName(property.name)}
          </span>
          <ChevronDown className={cx(Styles.chevronDown, { [Styles.disabled]: !canAct })} />
        </div>
      </div>
      {actionsOpen && (
        <PropertyActions
          property={property}
          availableProperties={availableProperties}
          onSearch={onSearch}
          onCreate={onCreate}
          onUpdate={onUpdate}
          onRemove={onRemove}
          onCancel={() => openPropertyActions && openPropertyActions(undefined)}
        />
      )}
    </>
  )
}
